function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var GuatemalaFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "a",
    width: "24",
    height: "18",
    x: "0",
    y: "3",
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: 'luminance'
    },
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#58A5FF",
      fillRule: "evenodd",
      d: "M16.5 3H24v18h-7.5V3ZM0 3h9v18H0V3Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M7.5 3h9v18h-9V3Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#C6C6C6",
      d: "m9.573 15.778-.544-.515 5.765-6.096.545.515-5.766 6.096Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#5AB92D",
      fillRule: "evenodd",
      d: "M9.739 9.08s-1.846 1.113-1.846 3.905c0 2.793 4.493 3.17 4.493 3.17s-2.689-1.64-3.04-2.814c-.353-1.174.393-4.262.393-4.262Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#5AB92D",
      fillRule: "evenodd",
      d: "M14.29 9.08s1.846 1.113 1.846 3.905c0 2.793-4.493 3.17-4.493 3.17s2.826-1.62 3.222-3.17c.396-1.55-.574-3.906-.574-3.906Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#5AB92D",
      d: "m11.106 8.7.747.067c-.025.271.123.547.489.842 1.176.952 1.808 2.139 1.313 3.488-.36.978-.848 1.805-1.466 2.476l-.552-.508c.549-.596.987-1.338 1.314-2.227.356-.969-.126-1.873-1.081-2.646-.544-.44-.814-.943-.764-1.492Z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#EFE298",
      fillRule: "evenodd",
      d: "m10.63 10.357.787 2.224h-.578s-.209.702.185.702h2.421s.264-.176.132-.702-.798-1.978-.798-1.978.285-.24.285-.42c0-.178-.285-.198-.285-.198h-1.796c-.23.04-.353.372-.353.372Z",
      clipRule: "evenodd"
    })]
  })]
}));
//# sourceMappingURL=Guatemala.js.map